<template>
    <div class="loadpage">
        <div v-loading="loading" class="pagess" element-loading-text="页面跳转中..."></div>
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="80%"
        >
            <span>您尚未登陆“实验空间”。请在<a href='http://www.ilab-x.com/details/v4?id=4401&isView=true'>“实验空间”</a>登陆后再点击“我要做实验”。</span>
            <a href='http://www.ilab-x.com/details/v4?id=4401&isView=true'><img style="width: 80%"
                                                                                src="../../../static/images/notice.png"
                                                                                alt=""></a>

        </el-dialog>
    </div>
</template>

<script>
    export default {
        props: {},
        data() {
            return {
                loading: true,
                dialogVisible: false,
                ruleForm2: {
                    username: "",
                    password: "",
                },
            };
        },
        computed: {},
        created() {
           var ticket1=window.location.href.split('ticket=')[1]
            var ticket= ticket1.split('&token')[0]
            if (ticket) {
                console.log(ticket)
                this.gettoken(ticket)
            } else {
                this.dialogVisible = true
            }
        },
        methods: {
//素描提交
            gettoken(token) {
                this.$http.third_plat({ticket:token})
                    .then(res => {
                        if (res.code == 200) {

                            this.ruleForm2.username = res.data.username
                            this.ruleForm2.password = '123456'
                            //登录
                            this.loginHandler()
                        } else {
                            this.$message.error(res.message)
                        }

                    })
            },
            GetQueryString(name) {
                console.log(this.$route.query)
                var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
                var r = window.location.search.substr(1).match(reg);  //匹配目标参数
                if (r!=null) return unescape(r[2]); return null; //返回参数值

            },
            loginHandler() {
                let params = {
                    username: this.ruleForm2.username,
                    password: this.ruleForm2.password
                };
                this.$http
                    .userLogin(params)
                    .then(res => {
                        if (res.code == 200) {
                            for (let key in res.data) {
                                this.$cookies.set(key, res.data[key]);
                            }
                            this.getUserInfo();
                        } else this.$message.error(res.message);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            checkLogin() {
                if (this.$cookies.get("token")) {
                    this.$router.push({name: "myInfo"});
                }
            },
            getUserInfo() {
                this.$http.getUserInfo().then(res => {
                    // 分发actions中getUserInfo方法  找store/index.js
                    this.$store.dispatch("SetUserInfo", res.data);
                    //返回之前的前面
                    this.$router.push(
                        this.$route.params.redirect
                            ? {path: this.$route.params.redirect}
                            : {name: "practiceList", params: {flag: 1}}
                    );
                });
            },

        },
    };
</script>

<style lang="less">
    .loadpage {
        .ts {
            text-align: center;
        }
        .pagess {
            height: 400px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/assessment/loadingpage.vue